export default function createScriptTag(src: string): HTMLScriptElement {
  const tag = document.createElement('script')
  tag.setAttribute('src', src)
  tag.setAttribute('type', 'text/javascript')
  return tag
}
